import Swal from "sweetalert2";
import { CONFIRM_COLOR, CANCEL_COLOR } from "./eventDialogs";

/**
 * Ask admin whether to keep places badge / reserve button visible on the client when marking an event full.
 * @returns {Promise<{ confirmed: boolean, clientShowPlacesWhenFull: boolean, clientShowReserveWhenFull: boolean }>}
 */
export async function promptEventFullClientOptions(t, defaults = {}) {
  const showPlacesDefault = defaults.clientShowPlacesWhenFull === true;
  const showReserveDefault = defaults.clientShowReserveWhenFull === true;

  const result = await Swal.fire({
    title: t("eventsFullClientOptionsTitle"),
    html: `
      <p class="events-full-options__text">${t("eventsFullClientOptionsText")}</p>
      <label class="events-full-options__label">
        <input type="checkbox" id="events-full-show-places"${showPlacesDefault ? " checked" : ""} />
        <span>${t("eventsFullClientShowPlaces")}</span>
      </label>
      <label class="events-full-options__label">
        <input type="checkbox" id="events-full-show-reserve"${showReserveDefault ? " checked" : ""} />
        <span>${t("eventsFullClientShowReserve")}</span>
      </label>
    `,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: t("eventsSave"),
    cancelButtonText: t("eventsCancel"),
    confirmButtonColor: CONFIRM_COLOR,
    cancelButtonColor: CANCEL_COLOR,
    focusConfirm: false,
    customClass: { htmlContainer: "events-full-options__container" },
    preConfirm: () => {
      const placesEl = document.getElementById("events-full-show-places");
      const reserveEl = document.getElementById("events-full-show-reserve");
      return {
        clientShowPlacesWhenFull: Boolean(placesEl?.checked),
        clientShowReserveWhenFull: Boolean(reserveEl?.checked),
      };
    },
  });

  if (!result.isConfirmed) {
    return { confirmed: false, clientShowPlacesWhenFull: false, clientShowReserveWhenFull: false };
  }

  return {
    confirmed: true,
    clientShowPlacesWhenFull: result.value?.clientShowPlacesWhenFull === true,
    clientShowReserveWhenFull: result.value?.clientShowReserveWhenFull === true,
  };
}

export const resetEventFullClientOptions = () => ({
  clientShowPlacesWhenFull: false,
  clientShowReserveWhenFull: false,
});
